import { Tabs } from "antd"
import React, { Component } from "react"
import { Col, FormGroup, Row } from "reactstrap"
import Input from "reactstrap/lib/Input"
import Icon from "./Icon"
import Section from "./Section"

const { TabPane } = Tabs

export default class Packages extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeKey: "1",
    }
  }

  newTabIndex = 0

  onChange = (activeKey) => {
    this.setState({ activeKey })
  }

  onEdit = (targetKey, action) => {
    this[action](targetKey)
  }

  add = () => {
    this.props.handleAddItem("push")
  }
  remove = (targetKey) => {
    this.props.handleAddItem("pop")
  }

  render() {
    const { activeKey, hideAdd, image } = this.state
    const { packages, idx, handleChange, parentState, auth } = this.props
    console.log(`packages`, packages)
    return (
      <Row>
        <Col lg="12">
          <Section title="Packages" className="pl-4">
            <Tabs
              type="editable-card"
              onChange={this.onChange}
              activeKey={activeKey}
              onEdit={this.onEdit}
              hideAdd={hideAdd}
            >
              {packages.map((pkg, pkgIdx) => {
                return (
                  <TabPane
                    tab={pkg.title}
                    key={pkg.key}
                    closable={pkg.closable}
                  >
                    <React.Fragment key={pkgIdx}>
                      <h4>{pkgIdx + 1}</h4>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={idx + "-package-title-" + pkgIdx}
                            >
                              Title
                            </label>
                            <Input
                              value={pkg.title}
                              id={idx + "-package-title-" + pkgIdx}
                              placeholder="Title"
                              type="text"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-title-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-title-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) => handleChange(e, pkgIdx, "title")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Title Should Be At Least 4 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={idx + "-package-cost-" + pkgIdx}
                            >
                              Cost ($)
                            </label>
                            <Input
                              value={pkg.cost}
                              id={idx + "-package-cost-" + pkgIdx}
                              placeholder="Cost"
                              type="text"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-cost-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-cost-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) => handleChange(e, pkgIdx, "cost")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Cost Should Be At Least 1 Character!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={idx + "-package-icon-" + pkgIdx}
                            >
                              Icon
                            </label>
                            {/* <Input
                              value={pkg.icon}
                              id={idx + "-package-icon-" + pkgIdx}
                              placeholder="Icon"
                              type="text"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-icon-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-icon-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) => handleChange(e, pkgIdx, "icon")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Icon Should Be At Least 5 Characters!
                            </div> */}
                            <Icon
                              image={pkg?.image}
                              setImage={(image) =>
                                handleChange(
                                  {
                                    target: {
                                      value: image,
                                      id: idx + "-package-icon-" + pkgIdx,
                                    },
                                  },
                                  pkgIdx,
                                  "image"
                                )
                              }
                              auth={auth}
                              setImagePath={(imagePath) =>
                                handleChange(
                                  {
                                    target: {
                                      value: imagePath,
                                      id: idx + "-package-icon-" + pkgIdx,
                                    },
                                  },
                                  pkgIdx,
                                  "icon"
                                )
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={idx + "-package-duration-" + pkgIdx}
                            >
                              Duration (Min)
                            </label>
                            <Input
                              value={pkg.duration}
                              id={idx + "-package-duration-" + pkgIdx}
                              placeholder="Minutes"
                              type="text"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-duration-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-duration-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) =>
                                handleChange(e, pkgIdx, "duration")
                              }
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Duration Should Be At Least 1 Character!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={
                                idx + "-package-shortDescription-" + pkgIdx
                              }
                            >
                              Short Description
                            </label>
                            <Input
                              value={pkg.shortDescription}
                              id={idx + "-package-shortDescription-" + pkgIdx}
                              placeholder="Short Description Of The Package"
                              type="textarea"
                              rows="4"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-shortDescription-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-shortDescription-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) =>
                                handleChange(e, pkgIdx, "shortDescription")
                              }
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Short Description Should Be At Least 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor={
                                idx + "-package-longDescription-" + pkgIdx
                              }
                            >
                              Long Description
                            </label>
                            <Input
                              value={pkg.longDescription}
                              id={idx + "-package-longDescription-" + pkgIdx}
                              placeholder="Long Description Of The Package"
                              type="textarea"
                              rows="4"
                              valid={
                                parentState.validation.form[
                                  idx + "-package-longDescription-" + pkgIdx
                                ] === "valid"
                              }
                              invalid={
                                parentState.validation.form[
                                  idx + "-package-longDescription-" + pkgIdx
                                ] === "invalid"
                              }
                              onChange={(e) =>
                                handleChange(e, pkgIdx, "longDescription")
                              }
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Long Description Should Be At Least 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </React.Fragment>
                  </TabPane>
                )
              })}
            </Tabs>
          </Section>
        </Col>
      </Row>
    )
  }
}
